import axios from './rest-axios';

const postfromqywx = (begin, end) => axios.post(`/manage/cw_zcdj/getfromqywx`, {begin, end});
const postfromqywxbyspno = (sp_no) => axios.post(`/manage/cw_zcdj/getfromqywx_byspno`, {sp_no});
const getAll = (data) => axios.get(`/manage/cw_zcdj`, {params: data});
const getwfl = (month) => axios.get(`/manage/cw_zcdj/wfl`, {month});
const getyfl = (month, md) => axios.get(`/manage/cw_zcdj/yfl`, {month, md});

const postadd = (ids, coa_id, md) => axios.post(`/manage/cw_zcdj/add`, {ids, coa_id, md});
const postremove = (ids) => axios.post(`/manage/cw_zcdj/remove`, {ids});
const getcwzcdjstat = (month, coa_name) => axios.get(`/manage/cw_zcdj/stat`, {month, coa_name});
const getcwzcdjstatyue = (year, coa_name) => axios.get(`/manage/cw_zcdj/statyue`, {year, coa_name});
const postmuti = (list) => axios.post(`/manage/cw_zcdj/postmuti`, {list});
const updatefkrq = (ids, fkrq) => axios.post(`/manage/cw_zcdj/updatefkrq`, {ids, fkrq});
const deletezcdj = (id) => axios.delete(`/manage/cw_zcdj/${id}`);

export {
    postfromqywx,
    postfromqywxbyspno,
    getwfl,
    getyfl,
    postadd,
    postremove,
    getcwzcdjstat,
    getcwzcdjstatyue,
    postmuti,
    getAll,
    updatefkrq,
    deletezcdj,
};